/* Our Farms mobile: menu drawer + sticky "Start my Box" bar */
(function(){
  var btn=document.querySelector('.of-menu-btn'), drawer=document.getElementById('of-drawer');
  if(btn&&drawer){
    var close=drawer.querySelector('.of-drawer-close');
    function set(open){ if(open){drawer.removeAttribute('hidden')}else{drawer.setAttribute('hidden','')}
      btn.setAttribute('aria-expanded',open); document.documentElement.style.overflow=open?'hidden':''; (open?close:btn).focus(); }
    btn.addEventListener('click',function(){set(true)});
    close.addEventListener('click',function(){set(false)});
    drawer.querySelectorAll('a').forEach(function(a){a.addEventListener('click',function(){set(false)})});
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!drawer.hasAttribute('hidden'))set(false)});
  }
  var bar=document.querySelector('.of-boxbar'), hero=document.querySelector('.of-s-hero .of-btns'), plans=document.getElementById('plans');
  if(bar&&hero&&'IntersectionObserver' in window){
    var heroVis=true, plansVis=false;
    function upd(){var show=!heroVis&&!plansVis; bar.classList.toggle('is-visible',show); bar.setAttribute('aria-hidden',!show)}
    new IntersectionObserver(function(e){heroVis=e[0].isIntersecting;upd()}).observe(hero);
    if(plans) new IntersectionObserver(function(e){plansVis=e[0].isIntersecting;upd()},{threshold:0.1}).observe(plans);
  }
})();
